module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('svg', {
    class: _vm.clazz,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, _vm._l((_vm.icon.paths), function(path) {
    return _c('path', {
      attrs: {
        "d": path.d,
        "fill": path.fill
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-0a717036!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./~/.1.0.4@vue-svg-icon/Icon.vue
// module id = 17
// module chunks = 1